import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class NumAbsentsService {
	constructor(private httpclientService: HttpclientService) {}
	loadNumAbsentsList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/NumAbsentsGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
